import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./solid/warning.svg";
var WarningSolid_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  WarningSolid_default as default
};
